import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import useAxios from '../axios/useAxios';
import {
  PIKKO_JACKPOT_DISPLAY_TYPE,
  PIKKO_JACKPOT_ELIGIBLE_DISPLAY_TYPES,
} from '../constants/pikkoJackpotConstants';
import { getJackpotOfferStatus, reactivateJackpotOffer, resetPikkoJackpot } from '../actions/pikkoJackpotActions';
import { PikkoJackpotConvertionContent } from '../components/pikko-jackpot/PikkoJackpotConvertionContent';


const PikkoJackpotScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const axiosInstance = useAxios();

  const cartItems = useSelector((state) => state.cart.cartItems);
  const user = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const { offerLoading, offer, offerError, reactivateLoading, reactivateError, reactivateSuccess } = useSelector((state) => state.jackpot);
  const [isOpen, setIsOpen] = useState(true);
  const [displayTypeOverride, setDisplayTypeOverride] = useState(null);

  const phoneNumber = user?.phoneNumber || cartItems?.phoneNumber;
  const storeId = store?.id || store?._id;

  useEffect(() => {
    dispatch(resetPikkoJackpot());
  }, [dispatch]);

  useEffect(() => {
    if (phoneNumber && storeId && orderId && axiosInstance) {
      dispatch(getJackpotOfferStatus(phoneNumber, storeId, orderId, axiosInstance));
    }
  }, [phoneNumber, storeId, orderId, axiosInstance, dispatch]);

  const displayType = displayTypeOverride || offer?.displayType || PIKKO_JACKPOT_DISPLAY_TYPE.NONE;
  const daysRemaining = displayTypeOverride
    ? Math.max(1, offer?.newDaysRemaining ?? offer?.daysRemaining ?? 5)
    : (offer?.daysRemaining ?? 0);

  const handleClose = (open) => {
    if (!open) {
      navigate(`/receipt/${orderId}`);
    }
    setIsOpen(open);
  };

  const _REACTIVATE_ERROR_MESSAGES = {
    JACKPOT_001: 'Aucune offre trouvée',
    JACKPOT_003: "L'offre n'est pas expirée",
    JACKPOT_005: "L'offre a déjà été réactivée",
    UNAUTHORIZED_REACTIVATION: 'Contexte de commande invalide',
    RATE_LIMIT_EXCEEDED: 'Trop de tentatives, réessayez plus tard',
  };

  const handleReactivate = () => {
    if (phoneNumber && orderId && axiosInstance) {
      dispatch(reactivateJackpotOffer(phoneNumber, orderId, axiosInstance));
    }
  };

  useEffect(() => {
    if (reactivateError) {
      const timeout = setTimeout(() => {
        navigate(`/receipt/${orderId}`);
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [reactivateError, navigate, orderId]);

  useEffect(() => {
    if (!(reactivateSuccess && isOpen)) return;
    setDisplayTypeOverride(PIKKO_JACKPOT_DISPLAY_TYPE.REMINDER);
  }, [reactivateSuccess, isOpen]);

  useEffect(() => {
    if (offerLoading) return;
    if (offerError || !phoneNumber || !storeId || cartItems?.itemsPrice == null) {
      navigate(`/receipt/${orderId}`);
    }
  }, [offerLoading, offerError, phoneNumber, storeId, cartItems, orderId, navigate]);

  useEffect(() => {
    if (offerLoading || displayTypeOverride) return;
    if (offer && !PIKKO_JACKPOT_ELIGIBLE_DISPLAY_TYPES.includes(displayType)) {
      navigate(`/receipt/${orderId}`);
    }
  }, [offerLoading, offer, displayType, displayTypeOverride, orderId, navigate]);

  if (offerLoading || !offer) {
    return null;
  }

  return (
    <PikkoJackpotConvertionContent
      isOpen={isOpen}
      setIsOpen={handleClose}
      displayType={displayType}
      cartItems={cartItems}
      daysRemaining={daysRemaining}
      expiresAt={offer?.expiresAt}
      onReactivate={handleReactivate}
      reactivateLoading={reactivateLoading}
    />
  );
};

export default PikkoJackpotScreen;
